export enum EVoxRoles {
    CLIENT = 0,
    MANAGER = 1,
    GUEST = 2,
    UNKNOWN = NaN,
}

/** Данные пользователя VOX */
export interface VOXUser {
    _id: string;
    data: {
        _id: string;
        name: string;
        phone?: string;
        photo?: {
            file_name: string;
            path: string;
        };
        position: string;
    };
    role?: EVoxRoles;
    /** id пользователя в vox */
    userId: number;
}

/** Данные конференции */
export interface VideoCall {
    _id: string;
    /** Идентификатор клиента ТР, для которого создана конференция */
    client_id: unknown;
    /** Идентификатор конференции */
    conference_name: number;
    created_at: string;
    /** Дата завершения звонка */
    ended_at: string | null;
    initiator_id: unknown;
    link_to_record: string;
    /** Список ID участников конференции */
    members: string[];
    session_id: number;
    started_at: string;
    updated_at: string;
}

export interface ErrorResponse {
    message: string;
    statusCode: number;
}

/** Данные записи встречи */
export interface IRecord {
    link_to_record: string;
}
